/** @format */

import React from "react";

export default function ContentTitle({ title }) {
   return <h2 className="lg:text-[3rem] text-[1.5rem] font-bold">{title}</h2>;
}
